export default "__VITE_ASSET__CmXT1zwc__"